<template>
    <div>
        <div id="main-wrapper">
            <navbar />

            <div class="page-wrapper" style="background-color: #fafafa">
                <router-view></router-view>
            </div>
        </div>

        <footer style="background-color: #363839">
            <div class="footer-copyright text-center py-3">
                <div
                    class="container-fluid text-center text-md-left"
                    style="margin-bottom: 15px;"
                >
                    <div class="row">
                        <div class="col-md-4 mt-md-0 mt-3"></div>
                        <div class="col-md-2 mt-md-0 mt-3">
                            <h5
                                class="text-uppercase font-weight-bold"
                                style="color: #bfbfbf; font-family: 'Open Sans', serif"
                            >
                                one.gen/0,1
                            </h5>
                            <p style="color: white">
                                {{ $t("footer.description") }}
                            </p>
                        </div>
                        <hr class="clearfix w-100 d-md-none pb-3" />
                        <div class="col-md-6 mb-md-0 mb-3">
                            <h5
                                class="text-uppercase font-weight-bold"
                                style="color: #bfbfbf; font-family: 'Open Sans', serif"
                            >
                                {{ $t("footer.help") }}
                            </h5>
                            <i class="mdi mdi-email-outline" /><a
                                href="mailto:info@onegen01.com"
                            >
                                info@onegen01.com</a
                            >
                            <br />
                            <i class="mdi mdi-cellphone-iphone" /><a
                                href="tel:+34935662808"
                            >
                                (+34) 93 566 28 08</a
                            >
                        </div>
                    </div>
                </div>
                <span style="color: white">&copy; {{ currentYear }}</span>
                <a href="https://onegen01.com"> Onegen 0,1</a>.
                <span style="color: white">{{ $t("footer.rights") }}</span>
            </div>
        </footer>
    </div>
</template>

<script>
import moment from "moment";
import Navbar from "./Onegen01Navbar";

export default {
    components: { Navbar },
    computed: {
        currentYear() {
            return moment().format("YYYY");
        }
    }
};
</script>
